import { EntityProps } from 'client/types'
import CommonBlogPostImage from 'common/components/entities/BlogPostImage'
import { BlogPostImageInterface } from 'common/types/entities/BlogPostImageInterface'
import React from 'react'
import { useTranslation } from 'react-i18next'
import Badge from '../../../components/core/Badge'
import BaseEntityNew from '../../../components/core/BaseEntity/BaseEntityNew'

function BlogPostImage({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<BlogPostImageInterface>) {
  const { t } = useTranslation()
  const blogPostImageUrl = `${process.env.EDITOR_ASSETS_HOST}/assets/images/blog_post_image_placeholder.png`

  return (
    <BaseEntityNew
      entity={entity}
      isMoveDownAllowed={isMoveDownAllowed}
      isMoveUpAllowed={isMoveUpAllowed}
    >
      <>
        <CommonBlogPostImage
          border={entity.border}
          mobileBorder={entity.mobileBorder}
          boxShadow={entity.boxShadow}
          mobileBoxShadow={entity.mobileBoxShadow}
          src={blogPostImageUrl}
          background={entity.background}
          mobileBackground={entity.mobileBackground}
        />
        <Badge wide>
          {t('entities.blog_post_image.warnings.do_not_remove')}
        </Badge>
      </>
    </BaseEntityNew>
  )
}

export default BlogPostImage
